import yearsBetweenDates from '../helpers/years-between-dates';

const minYear = age => (value, referenceDate) => {
  const years = yearsBetweenDates(value, referenceDate);
  return years >= age;
};

export default minYear;
